<template>
        <section class="my-lg-5 my-4">
            <div class="container">
                <div class="card bg-light">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 mb-lg-0 mb-3">
                                <h5>What You Get:</h5>
                                <div v-if="block.wyg.length" class="mb-3">
                                    <div v-for="(item, index) in block.wyg" :key="index" class="d-flex">
                                        <div class="align-self-center">
                                            <font-awesome-icon :icon="['far', 'check']" class="text-success" />
                                        </div>
                                        <div class="align-self-center ml-2">
                                            {{item}}
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <a  v-if="block.button_label" :href='block.button_uri' class='btn btn-outline-primary'>{{block.button_label}}</a>

                                    <button v-else type="button" class="btn btn-primary" @click.prevent="showModal('unpacking-modal')">
                                        Watch Unpacking Video
                                    </button>

                                    <b-modal id="unpacking-modal" size="lg" hide-footer centered>
                                        <template v-slot:modal-header>
                                            <button type="button" class="close" aria-label="Close" @click="closeModal('unpacking-modal')">
                                                <font-awesome-icon :icon="['fas', 'times']" />
                                            </button>
                                        </template>
                                        <template v-slot:default>
                                            <div class="embed-responsive embed-responsive-16by9">
                                                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/jah2uAqUfx8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                            </div>
                                        </template>
                                    </b-modal>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <h5>Key Features:</h5>
                                <div v-if="block.kf.length" class="mb-3">
                                    <div v-for="(item, index) in block.kf" :key="index" class="d-flex">
                                        <div class="align-self-center">
                                            <font-awesome-icon :icon="['far', 'check']" class="text-success" />
                                        </div>
                                        <div class="align-self-center ml-2">
                                            {{item}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    data: () => ({

    }),
    props: ['block'],
    components: {

    },
    methods: {
        showModal (modal) {
            this.$bvModal.show(modal)
        },
        closeModal (modal) {
            this.$bvModal.hide(modal)
        }
    },
    mounted () {

    }
}
</script>
